import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@klickdata/core/auth';
import { Customer } from '@klickdata/core/customer';
import { MessageSavedComponent, MessageService } from '@klickdata/core/message';
import { MobileService, SideNaveActionsTypes, SideNaveDataTypes } from '@klickdata/core/mobile';
import { ResourceOpportunityService } from '@klickdata/core/opportunity';
import { AppScope, Resource } from '@klickdata/core/resource';
import {
    Filter,
    GlobalFilterProperty,
    GlobalFilterPropertyType,
    SelectFilterOption,
    TableFilterComponent,
} from '@klickdata/core/table';
import { User } from '@klickdata/core/user';
import { ResourceApprovalsListingService } from '@klickdata/core/user-messages/src/user-messages/user-messages-center/user-messages-approvals/resource-approvals-listing.service';
import { Utils } from '@klickdata/core/util';
import { ShareService } from '@klickdata/shared-components/src/share/share.service';
import { UserTableBaseComponent } from '@klickdata/shared-components/src/user-table-base/user-table-base.component';
import { DownloadHelperService } from 'apps/klickdata/src/app/shared/dialog/download-pdf-dialog/download-helper.service';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { filter, map, Observable, switchMap, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'app-instructor-signoffs-users-listing',
    templateUrl: './instructor-signoffs-users-listing.component.html',
    styleUrls: ['./instructor-signoffs-users-listing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ResourceApprovalsListingService],
})
export class InstructorSignoffsUsersListingComponent extends OnDestroyHandler implements AfterViewInit, OnInit {
    @ViewChild('tableBase') tableBase: UserTableBaseComponent;
    @Input() authUser: User;
    @Input() tableFilterItems: Filter<any>[];
    @Input() approvalStatus: string;
    @Input() resource: Resource;
    @Output() onUpdateStatus: EventEmitter<void> = new EventEmitter();
    @ViewChild('name', { static: true }) name: TemplateRef<any>;
    @ViewChild('img', { static: true }) img: TemplateRef<any>;
    @ViewChild('registred_date', { static: true }) registred_date: TemplateRef<any>;
    @ViewChild('registration_status', { static: true }) registration_status: TemplateRef<any>;
    @ViewChild('tools', { static: true }) tools: TemplateRef<any>;
    @ViewChild('status_form', { static: true }) statusForm: TemplateRef<any>;
    @ViewChild(TableFilterComponent) filter: TableFilterComponent;
    GlobalFilterPropertyType = GlobalFilterPropertyType;
    public isMobile$: Observable<boolean>;
    public customer$: Observable<Customer>;
    public expandedRowId: number | null;
    GlobalFilterProperty = GlobalFilterProperty;
    columnsData: { [key: string]: TemplateRef<any> } = {};
    otherContext: { [key: string]: TemplateRef<any> } = {};
    public approvalStatusOptions: SelectFilterOption[];
    columnsKeys: any = {
        name: { label: $localize`Name`, sortable: true },
        img: { label: '', sortable: true },
        registred_date: { label: $localize`Signoff Date`, sortable: true },
        registration_status: { label: $localize`Decision`, sortable: true },
    };

    AppScope = AppScope;
    expandedFn = (user: User) => (user.opportunity_id || user.id) === this.expandedRowId;

    constructor(
        protected downloadHelper: DownloadHelperService,
        public shareService: ShareService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected cdr: ChangeDetectorRef,
        protected mobile: MobileService,
        protected auth: AuthService,
        protected messageService: MessageService,
        protected resourceEnrollmentsListingService: ResourceApprovalsListingService,
        protected resourceOpportunityService: ResourceOpportunityService
    ) {
        super();
        this.isMobile$ = mobile.isMobile();

        this.approvalStatusOptions = Utils.getResApprovalStatusOptions();
    }
    ngOnInit(): void {
        this.route.queryParams
            .pipe(
                filter((params) => params.expand),
                takeUntil(this.destroy)
            )
            .subscribe((params) => {
                setTimeout(() => {
                    this.expandedRowId = +params.expand;
                    this.cdr.markForCheck();
                }, 500);
            });
        this.customer$ = this.auth.getCustomer();
        setTimeout(() => {
            if (this.approvalStatus) {
                this.filter.setActiveFilterWithSelectedOption(GlobalFilterProperty.REVIEW_STATUS, this.approvalStatus);
            } else {
                this.filter.clear();
            }
        }, 100);
    }
    ngAfterViewInit(): void {
        this.columnsData['img'] = this.img;
        this.columnsData['name'] = this.name;
        this.columnsData['registred_date'] = this.registred_date;
        this.columnsData['registration_status'] = this.registration_status;
        this.columnsData['tools'] = this.tools;
    }

    browse(user: User) {
        this.router.navigate(['/admin/accounts/users/users/' + user.id + '/actions']);
    }
    public sendMsg(user: User) {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.SEND_MESSAGE,
            data: { model: user, isUser: true },
        });
    }

    onSelectStats(user: User) {
        this.router.navigate(['/admin/statistics/course-results/users'], {
            queryParams: {
                user_id: user.id,
            },
        });
    }

    sendEmail(user: User) {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.SEND_MAIL,
            data: user,
        });
    }
    onMessageSelected() {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.SEND_MESSAGE,
            data: { models: this.tableBase.dataSource.data, isMultipleUsers: true },
        });
    }
    onEmailSelected() {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.EMAIL_MULTIPLE_USERS,
            data: {
                type: 'emailMultipleUsers',
                users: this.tableBase.dataSource.data,
            },
        });
    }

    public updateAppprovmentOnTheFly(user: User, status: 'approved' | 'rejected' | 'pending') {
        this.resourceOpportunityService
            .postReviews(user.signoff.occasion_id, {
                approved: status === 'approved' ? true : status === 'rejected' ? false : null,
            })
            .pipe(takeUntil(this.destroy))
            .subscribe((oppo) => {
                this.onChangeStatus();
            });
    }
    onChngeStatus(user: User, status: 'approved' | 'rejected' | 'pending') {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.VALIDATE_SIGNOFF,
            data: {
                learner: user,
                occasion: {
                    resource: { title: this.resource.title },
                    signoff_at: user.signoff.signedoff_at,
                    id: user.signoff.occasion_id,
                },
                type: 'signoffApproval',
                title:
                    status === 'approved'
                        ? $localize`Update Approved`
                        : status === 'rejected'
                        ? $localize`Update Rejected`
                        : $localize`Update Waitinglist`,
                class: status === 'approved' ? 'green' : status === 'rejected' ? 'red' : 'orange',
            },
        });
        this.mobile
            .getSideNavResponseData()
            .pipe(
                takeUntil(this.destroy),
                filter((data) => data.type == 'signoffApproval' && !!data.oppo),
                map((data) => data.oppo)
            )
            .subscribe((occ) => {
                user.signoff.approval_status = occ.approved;
                this.onChangeStatus();
            });
    }
    private onChangeStatus() {
        this.cdr.markForCheck();
        this.messageService.openMessage(MessageSavedComponent, $localize`Signoff status updated`);
        this.onUpdateStatus.emit();
    }

    expansionToggled(user: User) {
        this.expandedRowId = this.expandedRowId === user.id ? null : user.id;
    }
}
